var pt = {
	seja_bem_vindo: "Seja bem-vindo",
	a_sua_gestao_de_assinaturas: "à sua gestão de assinaturas!",
	email: "E-mail",
	gerar_codigo_acesso: "Gerar código de acesso",
	confirme_seu_email: "Confirme seu e-mail",
	para_receber_o_codigo: "para receber o código",
	is_required: "é obrigatório",
	invalid_email: "E-mail inválido",
	acessar: "Acessar",
	enviamos_email_para: "Enviamos um código para",
	nao_recebi_email: "Não recebi o e-mail.",
	reenviar_codigo: "Reenviar código.",
	dados_pessoais: "Dados pessoais",
	visao_geral: "Visão Geral",
	minhas_assinaturas: "Minhas assinaturas",
	acessar_loja: "Acessar loja",
	nome_assinatura: "Nome da assinatura",
	nome_assinatura_placeholder: "Digite o nome da assinatura",
	alterar_nome: "Alterar nome",

	status: "Status",
	status_ativas: "Ativas",
	status_pendentes: "Pendentes",
	status_canceladas: "Canceladas",
	status_pausadas: "Pausadas",
	status_ativa: "Ativa",
	status_pausada: "Pausada",
	status_pendente: "Pendente",
	status_cancelada: "Cancelada",

	table_loja: "Loja",
	table_status: "Status",
	table_valor: "Valor",
	table_gerenciar: "Gerenciar",
	table_visualizar: "Visualizar",

	nenhuma_subscricao: "Nenhuma assinatura",
	nenhum_produto_disponivel: "Nenhum produto disponível",

	anterior: "Anterior",
	proximo: "Próximo",
	detalhes_da_assinatura: "Detalhes da assinatura",
	produtos_da_assinatura: "Produtos",
	assinatura: "Assinatura",
	proxima_cobranca: "Próxima renovação",
	adicionar: "Adicionar",
	adicionar_na_assinatura: "Adicionar na assinatura",
	adicionar_apenas_na_proxima_cobranca: "Adicionar apenas na próxima renovação",
	produto_de_compra_unica: "Produto de compra única",
	adicionar_produto: "Adicionar produto",
	adicionar_produtos: "Adicionar produtos",
	produto: "Produto",
	produtos: "produtos",
	produtos_disponiveis: "Produtos disponíveis",
	da_assinatura: "da assinatura",
	da_proxima_cobranca: "da próxima cobrança", 
	codigo_assinatura: "Código da assinatura",
	plano: "Plano",
	valor_assinatura: "Valor da assinatura",
	gerenciar: "Gerenciar",
	forma_pagamento_titulo: "Alterar",
	forma_pagamento: "Forma de pagamento",
	pagamento: "Pagamento",
	cartao_credito: "Cartão de Crédito",
	payment_link: "Link de pagamento",
	data_renovacao: "Data de renovação",
	cancelar_assinatura: "Cancelar assinatura",
	historico: "Histórico",
	data_pagamento: "Data",
	valor: "Valor",
	quantidade: "Quantidade",
	valor_unit: "Valor unitário",
	valor_do_frete: "Valor do frete",
	desconto: "Desconto",
	total: "Total",
	preco: "Preço",
	valor_total: "Valor total",
	total_proxima_renovacao: "Total da próxima renovação",
	comprovante: "Comprovante",
	confirm: "Confirmar",
	nenhum_historico: "Nenhum histórico",
	voce_deseja: "Você deseja",
	a_proxima_cobranca: "a próxima renovação?",
	sua_assinatura: "sua assinatura?",
	nao_cancelar: "Não cancelar",
	sim_quero_cancelar: "Sim, quero cancelar",
	exibir_mais: "Exibir mais",
	exibir_menos: "Exibir menos",
	add_new_card: "Adicionar novo cartão",
	gerenciar_assinatura: "Gerenciar assinatura",
	caracteres_invalidos: "Caracteres inválidos",
	maximo_20_caracteres: "Máximo de 20 caracteres",

	feedback: "Feedback",
	pesquisa_de_satisfacao: "Pesquisa de satisfação",
	experiencia_gestao: "Como você avalia a experiência de gerenciar suas assinaturas?",
	experiencia_produtos: "Qual é o seu nível de satisfação com os produtos adquiridos?",
	sugestao_melhorias: "Deixe sugestões de melhoria! (opcional)",
	enviar_feedback: "Enviar feedback",

	boleto: "Boleto",
	boleto_flash: "Boleto Flash",
	pec: "Em Dinheiro",
	pix: "Pix",
	pix_automatico: "Pix Automático",
	pix_automatico_desc: "Modalidade do Pix que permite pagamentos recorrentes de forma automática.",
	cartao_debito: "Cartão de Débito",
	paypal: "PayPal",

	qual_motivo: "Qual o motivo",
	do_cancelamento: "do cancelamento?",
	nao_desejo_receber_produto: "Não desejo mais receber o produto/serviço",
	nao_estou_satisfeito: "Não estou satisfeito com o produto/serviço",
	renovacao: "Você receberá por e-mail um link para efetuar o pagamento na data da próxima renovação.",
	next_billing: "Essa alteração será aplicada a partir do próximo ciclo de renovação. Deseja confirmar?",
	a_proxima_cobranca_sera: "A próxima renovação será em: ",
	me_arrependi: "Me arrependi da compra",
	outro_motivo: "Outro motivo",
	motivo: "Motivo",

	nao_pausar: "Não pausar",
	sim_quero_pausar: "Sim, quero pausar",

	nao_pular: "Não pular",
	sim_quero_pular: "Sim, quero pular",

	concordo: "Concordo",

	nao: "Não",
	sim: "Sim",
	de: "de",

	add: "Adicionar cartão",
	edit: "Editar",
	delete: "Excluir",
	delete_card: "Excluir cartão",
	activate: "Ativar",
	pause: "Pausar",
	skip: "Pular",
	cancel: "Cancelar",
	skippedDate: "Você pulou a renovação do dia {skippedDate}.",
	nextDate: "A próxima renovação está agendada para {nextDate}.",
	update_subscription: "Atualizar assinatura",
	add_products: "Adicionar produtos",
	products_search: "Buscar produtos",

	titular: "Nome do titular",
	numero_cartao: "Número do cartão",
	validade: "Validade",
	cvv: "CVV",

	change: "Alterar",
	adicionar: "Adicionar",

	days: "dias",
	day: "dia",
	weeks: "semanas",
	week: "semana",
	months: "meses",
	month: "mês",
	quarters: "semestres",
	quarter: "semestre",
	years: "anos",
	year: "ano",

	cc_month: "Mês",
	cc_year: "Ano",

	warning: "Aviso",
	this_card: "para este cartão?",
	confirm_change: "Sim, quero alterar",
	deny_change: "Não alterar",
	charge_subscription: "Ao trocar o cartão titular de uma assinatura com o pagamento pendente, será realizada uma tentativa de cobrança no novo cartão. Você deseja efetivar a troca de cartão?",

	tooltip_delete_product: "Remover produto",
	tooltip_processing: "Sua assinatura está em processamento.",
	tooltip_paused: "Sua assinatura está pausada.",
	tooltip_cvv:
		"O CVV do cartão é o código de segurança de 3 dígitos no verso do cartão, logo após o número. <br><br>Nos cartões American Express, são 4 dígitos na frente do cartão, acima do final do número do cartão.",

	erro_token: "Código inválido.<br/>Por favor, verifique seu e-mail e tente novamente.",
	invalid_creditcard: "Verifique o número do cartão",
	invalid_month: "Verifique o mês de vencimento",
	invalid_year: "Verifique o ano de vencimento",
	invalid_field: "Preencha o campo",

	atencao: "Atenção",
	cobranca_agendada_aviso: "A cobrança deste ciclo já foi agendada. A troca do método de pagamento estará disponível após a conclusão do pagamento.",

	sair: "Sair",
};

export default pt;
